/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGroupsListQueryResponse } from "../models/StationsStationsGroupsList";

export function getStationsStationsGroupsListUrl() {
  const res = { method: 'GET', url: `/station-groups/v1` as const }
  return res
}

/**
 * @description Returns all stations groups for the authenticated client, including their stations.
 * @summary List stations groups
 * {@link /station-groups/v1}
 */
export async function stationsStationsGroupsList(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StationsStationsGroupsListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationsStationsGroupsListUrl().url.toString(), ... requestConfig })
  return res.data
}